import { ModulePagesRouter } from '@platform/features/modules/ModulePagesRouter';
import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';
import { RecordListPage } from '@platform/engine/list/RecordListPage';

/** Третій сегмент модуля `/:group/:module/:entityOrPage` (ADR-028): сутність модуля — список типу, інакше — сторінка модуля. */
export function EntityOrPageRoute() {
  const { rt } = useWorkspaceParams();
  return rt ? <RecordListPage /> : <ModulePagesRouter />;
}
